<template>
    <div class="mt-2">
        <div>
            <div class="flex justify-between items-center mb-6">
                <div>
                    <h1 class="text-2xl font-bold text-gray-800 dark:text-white">Líderes de Setores</h1>
                    <p class="text-gray-600 dark:text-gray-400 mt-1">Lista de todos os líderes em todos os setores</p>
                </div>
                <button 
                    @click="$router.push('/sectors')" 
                    class="bg-gray-500 hover:bg-gray-600 text-white py-2 px-4 rounded-md flex items-center"
                >
                    <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"></path>
                    </svg>
                    Voltar
                </button>
            </div>
            
            <!-- Filtro de pesquisa -->
            <div class="mb-6 bg-gray-100 dark:bg-gray-900 p-4 rounded-lg">
                <div class="flex flex-col md:flex-row gap-4">
                    <div class="flex-grow">
                        <input
                            v-model="searchTerm"
                            type="text"
                            placeholder="Buscar por nome ou email..."
                            class="w-full px-4 py-2 rounded-md border border-gray-300 dark:border-gray-700 dark:bg-gray-800 dark:text-white"
                            @input="filterLeaders"
                        />
                    </div>
                </div>
            </div>
            
            <!-- Lista de líderes -->
            <div>
                <table-component
                    :loading="loading"
                    :headers="[
                        'Nome',
                        'Email',
                        'Setor',
                        'Ações'
                    ]"
                >
                    <tr v-for="leader in filteredLeaders" :key="`${leader.id}-${leader.sector.id}`" class="hover:bg-gray-100 dark:hover:bg-gray-700">
                        <td class="table-cell-sm">
                            <div class="flex items-center">
                                <div class="ml-3">
                                    <p class="text-gray-900 dark:text-white whitespace-no-wrap">
                                        {{ leader.name }}
                                    </p>
                                </div>
                            </div>
                        </td>
                        <td class="table-cell-sm">
                            <p class="text-gray-900 dark:text-white whitespace-no-wrap">
                                {{ leader.email }}
                            </p>
                        </td>
                        <td class="table-cell-sm">
                            <p class="text-gray-900 dark:text-white whitespace-no-wrap">
                                {{ leader.sector.name }}
                            </p>
                        </td>
                        <td class="table-cell-sm">
                            <button 
                                @click="viewSectorLeaders(leader.sector.id)" 
                                class="bg-blue-500 hover:bg-blue-600 text-white py-1 px-2 rounded-md text-xs mr-2"
                            >
                                Ver Setor
                            </button>
                        </td>
                    </tr>
                    <tr v-if="filteredLeaders.length === 0">
                        <td colspan="4" class="table-cell-sm text-center text-gray-500 dark:text-gray-400">
                            Nenhum líder encontrado.
                        </td>
                    </tr>
                </table-component>
            </div>
        </div>
    </div>
</template>

<script>
import TableComponent from "../../components/layouts/table/TableComponent.vue";

export default {
    components: {
        TableComponent
    },
    data() {
        return {
            leaders: [],
            filteredLeaders: [],
            searchTerm: '',
            loading: false
        }
    },
    
    mounted() {
        this.fetchLeaders();
    },
    
    methods: {
        fetchLeaders() {
            this.loading = true;
            axios.get('/api/sector-leaders')
                .then(response => {
                    this.leaders = response.data.leaders;
                    this.filteredLeaders = [...this.leaders];
                    this.loading = false;
                })
                .catch(error => {
                    console.error('Erro ao carregar líderes:', error);
                    this.loading = false;
                    this.$notify({
                        group: 'error',
                        title: 'Erro',
                        text: 'Erro ao carregar líderes. Tente novamente mais tarde.'
                    }, 4000);
                });
        },
        
        filterLeaders() {
            if (!this.searchTerm.trim()) {
                this.filteredLeaders = [...this.leaders];
                return;
            }
            
            const term = this.searchTerm.toLowerCase();
            this.filteredLeaders = this.leaders.filter(leader => 
                leader.name.toLowerCase().includes(term) || 
                leader.email.toLowerCase().includes(term) ||
                leader.sector.name.toLowerCase().includes(term)
            );
        },
        
        viewSectorLeaders(sectorId) {
            this.$router.push(`/sectors/${sectorId}/leaders`);
        }
    }
}
</script> 